import { render, staticRenderFns } from "./AttachedDocument.vue?vue&type=template&id=7fc5fc86"
import script from "./AttachedDocument.vue?vue&type=script&lang=ts"
export * from "./AttachedDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc5fc86')) {
      api.createRecord('7fc5fc86', component.options)
    } else {
      api.reload('7fc5fc86', component.options)
    }
    module.hot.accept("./AttachedDocument.vue?vue&type=template&id=7fc5fc86", function () {
      api.rerender('7fc5fc86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/AttachedDocument.vue"
export default component.exports